<template>
  <svg width="35"
       height="24"
       viewBox="0 0 35 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M21.55 24L19.84 20.3774C21.7 20.2566 22.96 19.3811 23.62 17.7509C24.34 16.1208 24.7 13.6151 24.7 10.234H19.93V0H30.46C30.46 1.44906 30.46 2.9283 30.46 4.43774C30.46 5.88679 30.46 7.33585 30.46 8.7849C30.46 13.4943 29.8 17.1472 28.48 19.7434C27.16 22.4 24.85 23.8189 21.55 24ZM5.71 24L4 20.3774C5.86 20.2566 7.12 19.3811 7.78 17.7509C8.5 16.1208 8.86 13.6151 8.86 10.234H4.09V0H14.62C14.62 1.44906 14.62 2.9283 14.62 4.43774C14.62 5.88679 14.62 7.33585 14.62 8.7849C14.62 13.4943 13.96 17.1472 12.64 19.7434C11.32 22.4 9.01 23.8189 5.71 24Z"
          fill="#009CD4" />
  </svg>
</template>
